// constructor shims
require('./shim/HTMLDocument');
require('./shim/CustomEvent');

// method shims
require('./shim/Element.matches');
require('./shim/Element.closest');
require('./shim/Element.mutation');
require('./shim/Element.classList');



//////////////////
// WEBPACK FOOTER
// ./~/dom-shims/index.js
// module id = 341
// module chunks = 0